import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { batch_get_all } from "../../util/Apiendpoits";
import { getWithTokenAPI } from "../../util/Api";
import { FiEye } from "react-icons/fi";
import DynamicTable from "../ReusableComponent/DynamicTable";
import { FiFileText, FiVideo, FiCalendar } from "react-icons/fi";

import { useNavigate } from "react-router-dom";
import TableSkeleton from "../ReusableComponent/TableSkeleton";
const TotalBatches = () => {
  const { token, userId } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  // --- State for Table ---
  const [loading, setLoading] = useState(false);
  const [batches, setBatches] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);

  // --- Fetch Data ---
  const fetchBatchList = async () => {
    try {
      setLoading(true);
      let queryUrl = `${batch_get_all}${userId}`;
      if (search) {
        queryUrl += `&search=${search}`;
      }
      const res = await getWithTokenAPI(token, queryUrl);

      if (res?.statusCode === 200) {
        const rawData = res.data.data || [];
        const groupedMap = {};
        
        rawData.forEach((item) => {
          const name = item.testBatchName;
          if (!groupedMap[name]) {
            groupedMap[name] = {
              ...item,
              id: item._id,
              totalTests: item.numberofTests || 1
            };
          }
        });

        const formattedData = Object.values(groupedMap);
        setBatches(formattedData);
      } else {
        setBatches([]);
      }
    } catch (error) {
      console.error("Batch list API error:", error);
      setBatches([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchBatchList();
    }, 500); // Wait for 500ms before calling the API

    return () => clearTimeout(delayDebounceFn);
  }, [search]);

  const handleBatchClick = (row) => {
    navigate(`/batches/details/${row.id}`, { state: { batch: row } });
  };

  const getColumns = () => [
    {
      key: "batchName",
      label: "Batch Name",
      render: (row) => (
        <span
          style={{
            fontWeight: 700,
            color: "#0b5ed7",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: "6px"
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleBatchClick(row);
          }}
        >
          {row.testBatchName}
        </span>
      ),
    },

    {
      key: "examType",
      label: "Exam Type",
      render: (row) => row.examType?.value || "N/A",
    },

    {
      key: "totalTests",
      label: "Total Tests",
      render: (row) => (
        <span
          style={{
            display: "inline-block",
            padding: "2px 10px",
            borderRadius: "12px",
            background: "#eff6ff",
            color: "#1d4ed8",
            fontWeight: 600,
            fontSize: "13px"
          }}
        >
          {row.totalTests || 0}
        </span>
      ),
    },

    {
      key: "fees",
      label: "Batch Fees",
      render: (row) => (
        <strong style={{ color: "#059669" }}>
          ₹{row.testFees || 0}
        </strong>
      ),
    },

    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <button
          className="view-btn-action"
          style={{
            fontSize: "13px",
            padding: "6px 14px",
            gap: "6px",
            display: "inline-flex",
            alignItems: "center"
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleBatchClick(row);
          }}
        >
          <FiEye size={15} />
          View Details
        </button>
      ),
    },
  ];

  // --- Filter Definitions ---
  const filters = [];

  const handleFilterChange = (key, option) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [key]: option,
    }));
  };

  return (
    <div className="batch-list-page" style={{ padding: "20px" }}>
      <div style={{ marginBottom: "20px" }}>
        <h2>Total Batches</h2>
      </div>

      {loading ? (
        <TableSkeleton columns={getColumns()} rows={5} hasActions={true} />
      ) : (
        <DynamicTable
          columns={getColumns()}
          data={batches}
          filters={filters}
          search={search}
          setSearch={setSearch}
          selectedFilters={selectedFilters}
          handleFilterChange={handleFilterChange}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          onSearchClick={fetchBatchList}
          onRowClick={handleBatchClick}
          activeTab="All"
        />
      )}
    </div>
  );
};

export default TotalBatches;